import { CapabilityBase } from '@trimble/web3d-capabilities';

/**
 * Used to group capabilities that are added to registry.
 */
export class CapabilitiesCollection<T extends CapabilityBase> {
  constructor(public readonly capabilities: T[] = []) {}

  public async cleanup(): Promise<void> {
    const cleanupPromises: Promise<void>[] = [];

    for (const capability of this.capabilities) {
      cleanupPromises.push(capability.cleanup());
    }

    await Promise.all(cleanupPromises);
  }
}
